import { useLanguage } from "../context/LanguageContext";

export const LanguageSwitch = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div className="lang-switch" role="group" aria-label="Language / Язык">
      <button
        className={lang === "ru" ? "active" : ""}
        onClick={() => setLang("ru")}
        aria-pressed={lang === "ru"}
      >
        RU
      </button>
      <span className="lang-divider">/</span>
      <button
        className={lang === "en" ? "active" : ""}
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
      >
        EN
      </button>
    </div>
  );
};
